import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { AppContext } from '../../contexts/AppContext';
import mainLogo from '../../images/plan-a-media-group.png';

export default function Header() {
  const { useMobileView } = useContext(AppContext);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const drawerWidth = 200;

  const menuItems = [
    {
      text: 'Who',
      href: '/#who',
    },
    {
      text: 'Group',
      href: '/#group',
    },
    {
      text: 'What',
      href: '/#what',
    },
    {
      text: 'Services',
      href: '/#services',
    },
    {
      text: 'Contact',
      href: '/#contact',
    },
  ];

  const appBarStyles = {
    backgroundColor: 'black',
    color: 'white'
  };

  const firstLinkStyle = {
    cursor: 'pointer',
    color: 'white',
    textDecoration: 'none',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    size: '1rem',
    lineHeight: 1.5,
  }

  const linkStyles = {
    cursor: 'pointer',
    color: 'white',
    textDecoration: 'none',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    size: '1rem',
    lineHeight: 1.5,
    marginLeft: '36px',
  };

  const drawerStyle = {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      backgroundColor: 'black',
      color: 'white',
    },    
  };

  const displayMobile = () => {
    return (
      <Toolbar>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6} container justifyContent="flex-start">
            <Link to="/">
              <img src={mainLogo} alt="Plan A Media Group" />
            </Link>
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end">
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={() => setDrawerOpen(true)}
              sx={{
                '&:hover': {
                  color: 'red',
                },
              }}
            >
              <MenuIcon />
            </IconButton>
          </Grid>
          <SwipeableDrawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            onOpen={() => {}}
            sx={drawerStyle}
          >
            <IconButton
              size="large"
              color="inherit"
              aria-label="drawer"
              onClick={() => setDrawerOpen(false)}
              sx={{
                justifyContent: 'flex-end',
                '&:hover': {
                  color: 'red',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            <List>
              {menuItems.map((item) => (
                <HashLink
                  key={item.text}
                  to={item.href}
                  onClick={() => setDrawerOpen(false)}
                  style={{
                    cursor: 'pointer',
                    color: 'white',
                    textDecoration: 'none',
                    fontFamily: 'Montserrat',
                    '&:hover': {
                      color: 'red !important',
                    },
                  }}
                >
                  <ListItemText
                    primary={item.text}
                    sx={{
                      paddingLeft: '8px'
                    }}
                  />
                </HashLink>
              ))}
              <HashLink
                key="Studio A"
                to="/studioA"
                onClick={() => setDrawerOpen(false)}
                style={{
                  cursor: 'pointer',
                  color: 'white',
                  textDecoration: 'none',
                  fontFamily: 'Montserrat',
                  '&:hover': {
                    color: 'red !important',
                  },
                }}
              >
                <ListItemText sx={{ paddingLeft: '8px' }}>
                  Studio <span style={{ color: 'red' }}>A</span>
                </ListItemText>
              </HashLink>
              <HashLink
                key="Plan A Live"
                to="/planALive"
                onClick={() => setDrawerOpen(false)}
                style={{
                  cursor: 'pointer',
                  color: 'white',
                  textDecoration: 'none',
                  fontFamily: 'Montserrat',
                  '&:hover': {
                    color: 'red !important',
                  },
                }}
              >
                <ListItemText sx={{ paddingLeft: '8px' }}>
                  Plan <span style={{ color: 'red' }}>A</span> Live
                </ListItemText>
              </HashLink>
            </List>
          </SwipeableDrawer>
        </Grid>
      </Toolbar>
    );
  };

  const displayDesktop = () => {
    return (
      <Toolbar>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={2} />
          <Grid item xs={2} container justifyContent="flex-start">
            <Link to="/">
              <img
                src={mainLogo}
                alt="Plan A Media Group"
                style={{ transform: 'scale(1.25)' }}
              />
            </Link>
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end">
            <HashLink style={firstLinkStyle} to="/#who">
              Who
            </HashLink>
            <HashLink style={linkStyles} to="/#group">
              Group
            </HashLink>
            <HashLink style={linkStyles} to="/#what">
              What
            </HashLink>
            <HashLink style={linkStyles} to="/#services">
              Services
            </HashLink>
            <HashLink style={linkStyles} to="/#contact">
              Contact
            </HashLink>
            <HashLink style={linkStyles} to="/studioA">
              Studio <span style={{ color: 'red' }}>A</span>
            </HashLink>
            <HashLink style={linkStyles} to="/planALive">
              Plan <span style={{ color: 'red' }}>A</span> Live
            </HashLink>
          </Grid>
          <Grid item xs={2} />
        </Grid>
      </Toolbar>
    );
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <AppBar position="static" sx={appBarStyles}>
        {useMobileView ? displayMobile() : displayDesktop()}
      </AppBar>
    </Box>
  );
}